import { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton, DeleteButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow";
import classes from "./DealModal.css"
import axios from "../../../../axios";


class DealModal extends Component {

  state = {
    deal: {},
    valuesChanged: false,
  }

  
  componentDidMount() {
    if (this.props.selectedDeal) {
      this.setState({ deal: this.props.selectedDeal })
    }
  }


  // MARK: - Handlers

  updateProperty(property, value) {
    let deal = {...this.state.deal}
    deal[property] = value
    this.setState({ deal })
  }

  saveHandler = () => {

    // Validate fields
    let deal = this.state.deal

    // Convert dates to epoch
    deal.startDate = dateToEpoch(deal.startDate)
    deal.endDate = dateToEpoch(deal.endDate)

    // Sync to the backend
    axios.post("/deals/update", this.state.deal)

    // Close the modal view
    this.props.closeModal()
  }

  deleteHandler = () => {

    // Sync to the backend
    axios.delete("/deals/delete/" + this.state.deal._id, this.state.deal)

    // Close the modal view
    this.props.closeModal()
  }


  // MARK: - User interface

  render() {

    let createMode = !this.props.selectedDeal
    // Calculate whether any settings were changed
    let editsMade = false
    // Loop over all settings in props and compare to state
    if (this.props.selectedDeal) {
      for (let [name, value] of Object.entries(this.state.deal)) {
        if (this.props.selectedDeal[name] !== value) {
          editsMade = true
          break
        }
      }
    } else {
      // Create mode, so always true
      editsMade = true
    }
   

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={createMode ? "New deal" : "Edit deal"}
      >
        <SelectRow
          title="Customer"
          firstRow ultrawide increasedPadding
          value={this.state.deal.customer ? this.state.deal.customer : ""}
          onChange={(newValue) => this.updateProperty("customer", newValue.value )}
          options={this.props.customerOptions}
        />

        <InputRow
          title="Description"
          enabled ultrawide
          value={this.state.deal.description ?? ""}
          placeholder={"E.g. Lacroix special deal"}
          onChange={(event) => this.updateProperty("description", event.target.value)}
        />

        <InputRow
          title="Start date"
          enabled ultrawide
          value={this.state.deal.startDate ?? ""}
          placeholder={"E.g. 01/01/2025"}
          onChange={(event) => this.updateProperty("startDate", event.target.value)}
        />

        <InputRow
          title="End date"
          enabled ultrawide
          value={this.state.deal.endDate ?? ""}
          placeholder={"E.g. 31/12/2025"}
          onChange={(event) => this.updateProperty("endDate", event.target.value)}
        />

        <InputRow
          title="Number of gateways"
          enabled ultrawide
          value={this.state.deal.gatewayAmount ?? ""}
          placeholder={"E.g. 100"}
          onChange={(event) => this.updateProperty("gatewayAmount", event.target.value)}
        />

        <textarea
          className={classes.notesField}
          value={this.state.deal.notes}
          type="text"
          placeholder="Terms of the deal"
          onChange={(event) => this.updateProperty("notes", event.target.value)}>{this.state.deal.notes}
        </textarea>

        <ModalActions>
          {(editsMade || createMode) ? (
            <>
              <CancelButton onClick={this.props.closeModal}/>
              {!createMode && <DeleteButton onClick={this.deleteHandler}/>}
              <SaveButton onClick={this.saveHandler}>
                {this.props.createMode ? "Create" : "Save"}
              </SaveButton>
            </>
          ) : (
            <>
              <CancelButton onClick={this.props.closeModal}>Close</CancelButton>
              <DeleteButton onClick={this.deleteHandler}/>
            </>
          )}
        </ModalActions>
      </BaseModal>
    );
  }
}

function dateToEpoch(date) {
  
  if (date) {
    var parts = date ? date.split("/") : []
    if (parts.length === 3) {
      date = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10))
      return date.getTime() / 1000
    }
  }
  return undefined
}

export default DealModal
